import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { DomSanitizer  } from '@angular/platform-browser';
import { Lightbox } from 'ngx-lightbox';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-image-details',
  templateUrl: './image-details.component.html',
  styleUrls: ['./image-details.component.css']
})
export class ImageDetailsComponent implements OnInit {

  images: any[]=[];
  albums: any[]=[];
  paramId: string;
  Title: string;
  Details: string;

  constructor(private service: DataService,
    public sanitizer: DomSanitizer,
    private lightbox: Lightbox,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
      if(this.activatedRoute.snapshot.paramMap.get('id') != null || this.activatedRoute.snapshot.paramMap.get('id') != undefined) {
        this.paramId = this.activatedRoute.snapshot.paramMap.get('id');
      } else {
        this.router.navigateByUrl('/img-gallery');
      }   
    }

  ngOnInit() {   
    var ImageData = JSON.parse(localStorage.getItem('imageData'));
    this.images = ImageData[this.paramId];
    this.Title = this.images['Title'];
    this.Details =  this.images['Details'];
    this.createGallery();
  }

createGallery() {
  for (let i = 0; i < this.images['ImgArray'].length; i++) {
    const src = this.images['ImgArray'][i].image;
    const caption = 'Image ' + i + ' caption here';
    const thumb = this.images['ImgArray'][i].image;
    const album = {
       src: src,
       caption: caption,
       thumb: thumb
    };
    this.albums.push(album);
  }
}

open(index) {
  // open lightbox
  this.lightbox.open(this.albums, index);
}

close() {
  // close lightbox programmatically
  this.lightbox.close();
}

}
